import React, { KeyboardEvent } from 'react'
import { Paper, Grid, TextField, Button, Typography, Box } from '@mui/material';
import { Person, Lock } from '@mui/icons-material'
import request from '../../helpers/myAxios';
import { Navigate, useNavigate } from 'react-router-dom';
import { ReactCookieProps, withCookies } from 'react-cookie';
import { AxiosError, AxiosResponse } from 'axios';
import { isUserLoggedIn } from '../../helpers/session'

import background from '../../images/background.png'; // Import using relative path

import { Trans } from 'react-i18next';
import i18next from '../../i18n';

interface LoginProps extends ReactCookieProps {
    onLogin: (user: any, token: string, expiresIn: number) => void
}

const Login = (props: LoginProps) => {
    let usernameInput: any = null;

    const [username, setUsername] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");
    const [errorMsg, setErrorMsg] = React.useState<string>("");

    const navigate = useNavigate();

    const handleLogin = () => {
        if (username && password) {
            const req = request();
            req.post('/auth', { username: username, password: password }).then((res: AxiosResponse) => {
                setUsername("");
                setPassword("");
                props.onLogin(res.data.user, res.data.token, res.data.expiresIn);
                navigate('/');
            }).catch((err) => {
                usernameInput?.focus();
                setErrorMsg(err.response.data.message);
            });
        }
        else {
            setErrorMsg(i18next.t('Login.msgNoUserOrPassword') as string);
            usernameInput?.focus();
        }
    }

    const handleKeyPress = (e: KeyboardEvent) => {
        if (e.key === 'Enter')
            handleLogin();
    }

    if (isUserLoggedIn())
        return <Navigate to="/gates" />;

    return (
        <Box sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundImage: `url(${background})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }}>
            <Box sx={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
            }}>
                <Paper sx={{
                    width: '400px',
                    margin: 'auto',
                    padding: '40px',
                    borderRadius: 1
                }}>
                    <Grid container spacing={1}>
                        <Grid item sm={3}>
                            <Person />
                        </Grid>
                        <Grid item sm={9}>
                            <TextField id="username" label={i18next.t('Login.username')} type="text" size='small' fullWidth autoFocus required value={username}
                                onChange={e => setUsername(e.target.value)} inputRef={input => usernameInput = input} />
                        </Grid>
                        <Grid item sm={3}>
                            <Lock />
                        </Grid>
                        <Grid item sm={9}>
                            <TextField id="password" label={i18next.t('Login.password')} type="password" size='small' fullWidth required value={password}
                                onChange={e => setPassword(e.target.value)} onKeyDown={handleKeyPress} />
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <Typography variant='caption' color='error' >{errorMsg}</Typography>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <Button variant="contained" color="primary" style={{ textTransform: "none" }} onClick={handleLogin} ><Trans i18nKey='Login.login' /></Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Box >
        </Box>
    )
}

export default withCookies(Login);

